<template>
    <div class="edit_wrap">
        <div class="pl10 pr10 mt20" style="word-break: break-all;">
            <div class="mt20 mb20" v-show="showReason" >
                <el-row>
                    <el-col :span="2">
                        <div class="grid-content">驳回原因：</div>
                    </el-col>
                    <el-col :span="22"><div class="grid-content"><span class="main_word">{{ scheduleObj.schedule }}</span></div></el-col>
                </el-row>
                <el-row>
                    <el-col :span="22" :offset="2">
                        <div class="grid-content" v-if="scheduleObj.content">({{scheduleObj.content}})</div>
                    </el-col>
                </el-row>
            </div>
            <p class="ml20">品牌品类基本信息</p>
            <div class="mt20 ml20">
                <el-form label-width="180px" class="demo-ruleForm">
                    <!-- 基础信息 -->
                    <el-form-item label="品牌品类申请编号：">
                        {{ infoData.agreementCode }}
                    </el-form-item>
                    <el-form-item label="关联供应商合同编号：">
                        {{ infoData.contractCode }}
                    </el-form-item>
                    <el-form-item label="供应商编号：">
                        {{ infoData.supplierCode }}
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        {{ infoData.supplierName }}
                    </el-form-item>
                    <el-form-item label="合作方式：">
                        {{ infoData.cooperationTypeDesc }}
                    </el-form-item>
                    <el-form-item label="结算主体：">
                        <span v-if="infoData.settlementBodyId==1">北京果敢时代科技有限公司</span>
                        <span v-if="infoData.settlementBodyId==2">MAMA HONG KONG</span>
                        <span v-if="infoData.settlementBodyId==3">天津果敢时代国际贸易有限公司</span>
                        <span v-if="infoData.settlementBodyId==4">正合奇胜（天津）企业咨询管理有限公司</span>
                        <span v-if="infoData.settlementBodyId==5">老师线下打款</span>
                    </el-form-item>
                    <el-form-item label="合同有效期：">
                        {{ infoData.startTime | time }}至{{ infoData.endTime | time }}
                    </el-form-item>
                </el-form>
            </div>
            <p class="ml20">品牌品类信息</p>
            <div class="mt20 mb20 clearfix">
                <el-table :data="infoData.agreementCategories" border style="width: 100%">
                    <el-table-column label="序号" width="74" align="center">
                        <template scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="品牌中文名称" min-width="80" align="center">
                        <template scope="scope">
                            <a :href="'#/supplierBrandDetail?agreementBrandId=' + scope.row.attributeId" target="_blank"><el-button type="text" size="small">{{ scope.row.brandName }}</el-button></a>
                        </template>
                    </el-table-column>

                    <el-table-column label="主营品类"
                                     width="200"
                                     align="center">
                        <template scope="scope">
                            <span>{{ scope.row.category.grandName }}--</span>
                            <span>{{ scope.row.category.parentName }}--</span>
                            <span>{{ scope.row.category.childrenName }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="是否提供发票"
                                     width="140"
                                     align="center">
                        <template scope="scope">
                            <span v-if="scope.row.provideInvoice==0">否</span>
                            <span v-if="scope.row.provideInvoice==1">是</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="发票类型" align="center" width="180">
                        <template scope="scope">
                            <span v-if="scope.row.provideInvoice==0">无</span>
                            <span v-if="scope.row.provideInvoice==1 && registeredCountry == 1 && scope.row.invoiceType == 1">增值税普通发票</span>
                            <span v-if="scope.row.provideInvoice==1 && taxpayerType==1 && registeredCountry == 1 && scope.row.invoiceType == 2">增值税专用发票</span>
                            <span v-if="scope.row.provideInvoice==1 && taxpayerType==2 && registeredCountry == 1 && scope.row.invoiceType == 2">增值税专用发票（需去税务局代开）</span>
                            <span v-if="scope.row.provideInvoice==1 && registeredCountry != 1 && scope.row.invoiceType == 3">形式发票</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="税率" align="center" min-width="150">
                        <template scope="scope">
                            <span v-if="scope.row.rates.length==0">无</span>
                            <span v-if="scope.row.rates.length>0" v-for="rateValue in scope.row.rates">
                                    {{rateValue}}%
                                    </span>
                        </template>
                    </el-table-column>

                    <el-table-column width="200" label="品类经营特许资质电子版" align="center">
                        <template scope="scope" >
                            <img v-if="scope.row.franchiseQualification == 1" @click="previewPic($event)"
                                 class="pic_skan" :src="scope.row.franchiseQualificationFile">
                            <span v-if="!scope.row.franchiseQualification == 1">不需要</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="statusDesc" label="合作状态" min-width="220" align="center"></el-table-column>

                    <el-table-column label="操作" align="center">
                        <template scope="scope">
                            <a target="_blank" :href="'#/supplierBrandDetail'+'?agreementBrandId=' + scope.row.attributeId">
                                <el-button type="text" size="small">查看</el-button>
                            </a>
                            <el-button v-if="editAuth && scope.row.status==1" @click="endAgreementCategory(scope.row.id, scope.row.type)" type="text" size="small">
                                终止合作
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="mb20" align="center">
                <el-button type="primary" @click="reback()">返回</el-button>
            </div>
            <!--预览图片弹框-->
            <el-dialog :visible.sync="dialogVisible" size="small">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>

        </div>
    </div>

</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                dialogVisible: false,   // 预览弹框状态
                dialogImageUrl: '',     // 预览弹框url
                showReason:false,       // 驳回原因 是否展示状态
                registeredCountry: 0,   // 注册地
                taxpayerType: 0,        // 纳税人类型
                deptId:0,               // 部门id
                categoryIsBook:0,       //
                categoryNotBook:0,      //
                editAuth: false,

                // 驳回原因 内容
                scheduleObj:{
                    schedule:"1",
                    content:"2"
                },
                agreementId: 0,
                infoData: {
                    // 品牌列表
                    agreementBrands: [

                    ]
                },


            }
        },
        methods: {
            fetch () {
                var that = this;
                $.get({
                    url: "/suppliers/brandAgreement/brandAgreement/find",
                    data: {
                        agreementId: that.agreementId
                    },
                    success: function (result) {
                        if (!result.code && result.data) {
                            console.log(result.data)
                            that.infoData = result.data;
                            that.registeredCountry = result.data.registeredCountry;
                            that.taxpayerType = result.data.taxpayerType;
                            that.deptId = result.data.deptId;
                            that.categoryIsBook = result.data.categoryIsBook;
                            that.categoryNotBook = result.data.categoryNotBook;
                        }
                    }
                })
            },

            // 预览图片
            previewPic (e) {
                this.dialogVisible = true;
                // 获取当前图片地址
                this.dialogImageUrl = e.currentTarget.src;
            },

            getUserAuth(){
                var that = this;
                $.get({
                    url: '/suppliers/brandAgreement/auth/find',
                    data: {
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.editAuth = result.data.edit;
                        } else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            endAgreementCategory(agreementCategoryId, type){
                var that = this;
                that.$confirm('此操作将终止协议, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var Data = {};
                    Data.agreementCategoryId = agreementCategoryId;
                    Data.brandAgreementId= that.agreementId;
                    Data.type = type;
                    $.ajax({
                        url: '/suppliers/brandAgreement/agreementCategory/end',
                        data: JSON.stringify(Data),
                        dataType: "json",
                        contentType: 'application/json;charset=utf-8',
                        type: 'POST',
                        success: function (result) {
                            if (!result.code) {
                                that.fetch();
                            } else {
                                that.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消终止'
                    });
                });
            },

            // 返回
            reback(){
                this.$router.push({
                    path:'/supplier_info?suppliersId=' + this.infoData.agreementBrands[0].supplierId+'&isStep=5'
                })
            },

        },

        mounted () {
            var agreementId = this.$route.query.agreementId;
            this.agreementId = agreementId;
            this.$nextTick(function () {
                this.fetch();
                this.getUserAuth();
            })
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .edit_wrap {
            margin: 50px auto;
            width: 1050px;
            border: 1px solid #eee;
        }
        .link_a {
            border-bottom: 1px solid red;
        }

        .pic_skan {
            box-sizing: border-box;
            margin-top: 10px;
            margin-right: 5px;
            width: 150px;
            height: 150px;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            cursor: pointer;
        }
</style>


// WEBPACK FOOTER //
// brandAgreement.vue?00b9af3f